import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const boldFontWeight = String(theme.fontWeightBold) as TextStyle['fontWeight']
  return {
    base: {
      fontFamily: theme.fontFamily.bold,
      fontWeight: boldFontWeight,
      textAlign: 'center',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      backgroundColor: 'transparent',
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeFourpulse,
      paddingLeft: theme.paddingInsetNone,
      paddingRight: theme.paddingInsetNone,
      paddingTop: theme.paddingInsetNone,
      paddingBottom: theme.paddingInsetNone,
      height: theme.sizingExtrasmall,
      flexShrink: 1,
      flexWrap: 'wrap',
      overflow: 'hidden',
      lineHeight: convertLineHeight(
        theme.fontSizeFourpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {},
  }
})
